import thunkMiddleware from 'redux-thunk';
import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from './rootReducer';
import { listenerMiddleware } from './listeners';

/* eslint-disable no-underscore-dangle */
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  rootReducer /* preloadedState, */,
  composeEnhancer(
    applyMiddleware(thunkMiddleware, listenerMiddleware.middleware),
  ),
);
/* eslint-enable */
